import React, { useState } from "react";
import RegisterVADoctors from "./RegisterVADoctors";
import CreateTestPatients from "./CreateTestPatients";
import Sidebar from "../Sidebar";

export default function VA({ setAuth, setUserOrg }) {
  const [activeTab, setActiveTab] = useState("register"); // "register" or "patients"

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
      <div
        className="w-full transition-all duration-200"
        style={{
          marginLeft: "var(--sidebar-width, 250px)",
          width: "calc(100% - var(--sidebar-width, 250px))",
        }}
      >
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              
              <h1 className="text-2xl font-bold text-ktx-purple">
                VA Admin Tools
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab("register")}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${activeTab === "register"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              Register VA Doctor
            </button>
            <button
              onClick={() => setActiveTab("patients")}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${activeTab === "patients"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              Create Test Patients
            </button>
          </nav>
        </div>
      </div>

      {/* Content Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {activeTab === "register" ? (
          <RegisterVADoctors />
        ) : (
          <CreateTestPatients />
        )}
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 text-sm text-gray-500">
        Current Tab: {activeTab === "register" ? "Register Doctor" : "Test Patients"}
      </div>
      </div>
    </div>
  );
};
